(function () {
	const getUniqueId = () => {
		const array = (
			Date.now() + Math.random().toString(36).substring(2, 9)
		).split("");

		for (let i = array.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[array[i], array[j]] = [array[j], array[i]];
		}

		return array.join("");
	};

	const getSelectedNodes = (selectors) => {
		const allNodes = document.querySelectorAll(selectors.join(", "));
		return Array.from(allNodes).filter(node => !node.classList.contains("tocifier-article-nav__title"));
	};

	const getWindowScrollProgress = () => {
		const height =
			document.documentElement.scrollHeight -
			document.documentElement.clientHeight;
		return 100 - (window.scrollY / height) * 100;
	};

	const generateNav = (nodes, highlighted) => {
		let navItems = [];
		for (const node of nodes) {
			if (node.classList.contains("tocifier-article-nav__title")) continue;

			const li = document.createElement("li");
			const a = document.createElement("a");

			const id = node.id || "id-" + getUniqueId();
			a.textContent = node.textContent;
			a.href = `#${id}`;

			if (highlighted.some(className => node.classList.contains(className))) {
				li.classList.add("tocifier-highlight");
			}

			if (!node.id) {
				node.id = id;
			}

			li.appendChild(a);
			navItems.push(li);
		}

		return navItems;
	};

	const selectors = tocifierSettings.selectors && tocifierSettings.selectors !== ''
		? [tocifierSettings.selectors]
		: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
	const highlighted = tocifierSettings.highlighted && tocifierSettings.highlighted !== ''
		? tocifierSettings.highlighted.split(',').map(item => item.replace('.', ''))
		: ['toc-highlight'];
	const nodes = getSelectedNodes(selectors);

	if (!nodes.length) return;

	const staticNav = document.getElementById("tocifier-contents-static");
	const stickyElement = document.querySelector(".has-sticky");
	const stickyNav = document.getElementById("tocifier-contents-sticky");
	const staticList = document.getElementById("tocifier-contents-static-list");
	const staticLists = document.querySelectorAll(".tocifier-contents-static-list");
	const stickyList = document.getElementById("tocifier-contents-sticky-list");
	const staticPanel = document.getElementById("tocifier-contents-static-panel");
	const staticExpand = document.getElementById("tocifier-contents-static-view-all");
	const details = document.querySelector(".tocifier-contents-sticky-details");
	const showAllButtons = document.querySelectorAll(".tocifier-contents-static-view-all");

	// When details window is open,is adding overflow: hidden in to body.
	if (details) {
		details.addEventListener('toggle', () => {
			if (details.hasAttribute('open')) {
				document.body.classList.add('tocifier-details-open');
			} else {
				document.body.classList.remove('tocifier-details-open');
			}
		});
	}

	if (showAllButtons.length > 0) {
		showAllButtons.forEach(function (btn) {
			btn.addEventListener('click', function (event) {
				event.preventDefault();

				btn.previousElementSibling.setAttribute('style', 'max-height: 100%;')
				btn.style.display = 'none';
			});
		});
	}

	// Skip navigation generation if data-has-static="true" is present
	const hasStaticData = document.querySelector('[data-has-static="true"]');
	if (hasStaticData) {
		// Turn off loading state for static navigation
		if (staticNav) {
			staticNav.classList.remove('loading');
		}
		
		// Check for overflow in static content to show/hide button
		staticLists.forEach(list => {
			const maxHeight = list.parentNode.style.maxHeight && list.parentNode.style.maxHeight.replace('px', '');
			if (maxHeight && list.scrollHeight > maxHeight) {
				list.closest('nav').classList.add('has-overflow-items');
			}
		});
		
		// Generate navigation items for sticky nav from static content
		const navItems = generateNav(nodes, highlighted);
		
		// Populate sticky navigation
		for (const item of navItems) {
			const clone = item.cloneNode(true);
			clone.addEventListener("click", (e) => {
				e.target.closest("details").open = false;
			});
			if (stickyList) stickyList.appendChild(clone);
		}
		
		// Set up sticky navigation scroll behavior
		if (!stickyElement) return;

		window.addEventListener("scroll", () => {
			const { top, height } = stickyElement.getBoundingClientRect();
			if (top + height < 0) {
				stickyNav.classList.remove("tocifier-contents-sticky--fade-out");
				stickyNav.classList.add("tocifier-contents-sticky--fade-in");
				stickyNav.hidden = false;
				return;
			}
			stickyNav.classList.remove("tocifier-contents-sticky--fade-in");
			stickyNav.classList.add("tocifier-contents-sticky--fade-out");
		});

		window.addEventListener("scroll", () => {
			const scrolled = getWindowScrollProgress();
			stickyNav.style.setProperty("--page-scroll-progress", scrolled + "%");

			let i = 0;
			for (const node of nodes) {
				const { top } = node.getBoundingClientRect();
				const listItem = stickyList.children[i];
				if (top <= 0 && listItem) {
					listItem.classList.add("is-item-active");
				} else if (listItem) {
					listItem.classList.remove("is-item-active");
				}
				i++;
			}
		});
		
		return;
	}

	const navItems = generateNav(nodes, highlighted);

	if (staticNav && navItems.length < 2) staticNav.remove();

	staticLists.forEach(list => {
		const maxHeight = list.parentNode.style.maxHeight && list.parentNode.style.maxHeight.replace('px', '');

		for (let i = 0; navItems.length > i; i++) {
			if (navItems[i].innerText === '') continue;
			const item = navItems[i].cloneNode(true);
			if (list) list.appendChild(item);
		}

		if (maxHeight && list.scrollHeight > maxHeight) list.closest('nav').classList.add('has-overflow-items');

		list.closest('nav').classList.remove('loading');
	});

	staticExpand && staticExpand.addEventListener("click", () => {
		staticPanel.hidden = true;
		for (const item of staticList.children) {
			item.hidden = false;
		}
	});

	for (const item of navItems) {
		const clone = item.cloneNode(true);
		clone.addEventListener("click", (e) => {
			e.target.closest("details").open = false;
		});
		if (stickyList) stickyList.appendChild(clone);
	}

	if (!stickyElement) return;

	window.addEventListener("scroll", () => {
		const { top, height } = stickyElement.getBoundingClientRect();
		if (top + height < 0) {
			stickyNav.classList.remove("tocifier-contents-sticky--fade-out");
			stickyNav.classList.add("tocifier-contents-sticky--fade-in");
			stickyNav.hidden = false;
			return;
		}
		stickyNav.classList.remove("tocifier-contents-sticky--fade-in");
		stickyNav.classList.add("tocifier-contents-sticky--fade-out");
	});

	window.addEventListener("scroll", () => {
		const scrolled = getWindowScrollProgress();
		stickyNav.style.setProperty("--page-scroll-progress", scrolled + "%");

		let i = 0;
		for (const node of nodes) {
			const { top } = node.getBoundingClientRect();
			const listItem = stickyList.children[i];
			if (top <= 0 && listItem) {
				listItem.classList.add("is-item-active");
			} else if (listItem) {
				listItem.classList.remove("is-item-active");
			}
			i++;
		}
	});
})();
